import { $ } from '@starberry/components';
import { Button } from '@chakra-ui/react';

export default {
  BaseButton: {
    component: Button,
    fontSize: 'md',
    lineHeight: '1.2',
    letterSpacing: '0.03em',
    fontWeight: 'semibold',
    padding: '10px 36px',
    borderRadius: '100px',
    boxShadow: 'none',
    bg: $('constants.colors.button'),
    _active: {
      boxShadow: 'none',
    },
    _focus: {
      boxShadow: 'none',
    },
  },

  PrimaryButton: {
    $: 'BaseButton',
    color: $('constants.colors.primaryTextContrast'),
    bg: $('constants.colors.button'),
    _hover: {
      color: $('constants.colors.primaryTextContrast'),
      bg: $('constants.colors.buttonPressed'),
    },
  },

  PrimaryButtonOutline: {
    $: 'BaseButton',
    border: '1px solid',
    color: $('constants.colors.primaryTextContrast'),
    bg: 'transparent',
    _hover: {
      color: $('constants.colors.primaryTextContrast'),
      bg: $('constants.colors.button'),
      borderColor: $('constants.colors.button'),
    },
  },

  SecondaryButton: {
    $: 'BaseButton',
    color: $('constants.colors.primaryTextContrast'),
    bg: $('constants.colors.button'),
    _hover: {
      color: $('constants.colors.primaryTextContrast'),
      bg: $('constants.colors.buttonPressed'),
    },
  },

  SecondaryButtonOutline: {
    $: 'BaseButton',
    bg: 'transparent',
    color: $('constants.colors.button'),
    border: '1px solid',
    borderColor: $('constants.colors.button'),
    _hover: {
      color: $('constants.colors.primaryTextContrast'),
      bg: $('constants.colors.button'),
      borderColor: $('constants.colors.button'),
    },
  },

  TertiaryButton: {
    $: 'BaseButton',
    color: $('constants.colors.primaryTextContrast'),
    bg: $('constants.colors.button'),
    _hover: {
      color: $('constants.colors.primaryTextContrast'),
      bg: $('constants.colors.buttonPressed'),
    },
  },

  TertiaryButtonOutline: {
    $: 'BaseButton',
    color: $('constants.colors.button'),
    bg: 'transparent',
    border: '1px solid',
    borderColor: $('constants.colors.button'),
    _hover: {
      color: $('constants.colors.primaryTextContrast'),
      bg: $('constants.colors.button'),
      borderColor: $('constants.colors.button'),
    },
  },
};
